module.exports = __webpack_public_path__ + "static/media/mq.9bf53e1d.svg";